$(document).ready(function () {
    $(".asjkdhki").show();
    $(".xzzx-b-r:eq(0)").show();
    $(".xzzx-b-r:eq(0)").siblings().hide();
    $("#inside_page").hide();
    $(".products_2023 a").on("click", function () {
        var index = $(this).index();
        $(".asjkdhki").show();
        $(".software2023_download").find(".xzzx-b-r").eq(index).show().siblings().hide();
        $(".software2023_download").siblings().find(".xzzx-b-r").hide();
        $("#inside_page").hide();
    });
    
    $(".products_2022 a").on("click", function () {
        var index = $(this).index();
        $(".asjkdhki").show();
        $(".software2022_download").find(".xzzx-b-r").eq(index).show().siblings().hide();
        $(".software2022_download").siblings().find(".xzzx-b-r").hide();
        $("#inside_page").hide();
    });
    
    $(".prevou_ones a").on("click", function () {
        var index = $(this).index();
        $(".asjkdhki").show();
        $(".pre_one_secs").find(".xzzx-b-r").eq(index).show().siblings().hide();
        $(".pre_one_secs").siblings().find(".xzzx-b-r").hide();
        $("#inside_page").hide();
    });
    
    $(".receones a").on("click", function () {  
        var index = $(this).index();
        $(".asjkdhki").show();
        $(".one_secs").find(".xzzx-b-r").eq(index).show().siblings().hide();
        $(".one_secs").siblings().find(".xzzx-b-r").hide();
        $("#inside_page").hide();
    });


          $(".xzzx-b-r2 #update_tool").on("click", function () {
              $("#asjkdhki").hide();
    $("#inside_page").show();
                });










  

});




    $(document).ready(function () {
        $("ul.kj li > div.t").click(function () {
            var arrow = $(this).find("span.arrow");
            if (arrow.hasClass("up")) {
                arrow.removeClass("up");
                arrow.addClass("down");
            } else if (arrow.hasClass("down")) {
                arrow.removeClass("down");
                arrow.addClass("up");
            }
            $(this).parent().siblings().each(function (index, el) {
                $(el).find("ul.menu").slideUp();
                $(el).find(".arrow").removeClass("up").addClass("down");
            });
            $(this).parent().find("ul.menu").slideToggle();
        });
        $("ul.kj li .menu li a").click(function () {
            // $(this).parents('li').find('.t').css('background','#0090ff').find('a').css('color','#fff');
            $(this).parent().siblings().each(function (index, el) {
                $(el).find(".sj_3ji").slideUp();
            });
            $(this).siblings('.sj_3ji').slideToggle();
        });



    $(".products_2023 a:nth-child(1)").addClass('selected');

        $(".products_2023 a").on("click", function () {
            $(this).siblings(".products_2023 a").removeClass('selected');
            $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
            $(this).addClass('selected');
        });


        $(".products_2022 a").on("click", function () {
            $(this).siblings(".products_2022 a").removeClass('selected');
            $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
            $(this).addClass('selected');
        });

        $(".prevou_ones a").on("click", function () {
            $(this).siblings(".prevou_ones a").removeClass('selected');
            $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
            $(this).addClass('selected');
        });


        $(".receones a").on("click", function () {
            $(this).siblings(".receones a").removeClass('selected');
            $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
            $(this).addClass('selected');
        });
        $(".recetwos a").on("click", function () {
            $(this).siblings(".recetwos a").removeClass('selected');
            $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
            $(this).addClass('selected');
        });
        $(".recethrees a").on("click", function () {
            $(this).siblings(".recethrees a").removeClass('selected');
            $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
            $(this).addClass('selected');
        });
        $(".recefours a").on("click", function () {
            $(this).siblings(".recefours a").removeClass('selected');
            $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
            $(this).addClass('selected');
        });








      
    });










 
    







